export const GET_LIST_COUNTRIES_REDUCER = 'GET_LIST_COUNTRIES_REDUCER';
export const GET_LIST_COUNTRIES_REQUEST = 'GET_LIST_COUNTRIES_REQUEST';
export const GET_LIST_COUNTRIES_MARKET_DATA_REDUCER = 'GET_LIST_COUNTRIES_MARKET_DATA_REDUCER';
export const GET_LIST_COUNTRIES_MARKET_DATA_REQUEST = 'GET_LIST_COUNTRIES_MARKET_DATA_REQUEST';

export const GET_LIST_COUNTRIES_MARKET_FORECAST_REDUCER = 'GET_LIST_COUNTRIES_MARKET_FORECAST_REDUCER';
export const GET_LIST_COUNTRIES_MARKET_FORECAST_REQUEST = 'GET_LIST_COUNTRIES_MARKET_FORECAST_REQUEST';